import { DEBUG } from "../../../../../../settings/global";
import country_data from "./data/countryData";
import * as flagsData from './data/dataCenters'

export function handleRegionFlag(region, currentCloud, regions) {

    // let cloudName = currentCloud['name'];
    let cloudCode = currentCloud['code'];
    let flag = {};
    let findCountryData = code => {
        let foundCountry = country_data.find(country => {
            let codeISO = country.iso_code; // not ISO anymore thanks to some providers
            if (typeof codeISO === 'string') {
                return codeISO.toUpperCase() === code.toUpperCase();
            } else if (Array.isArray(codeISO)) {
                return codeISO.some(c => c.toUpperCase() === code.toUpperCase());
            }
        });

        if (!!foundCountry) {
            return {src: foundCountry.flag, alt: foundCountry.country};
        } else {
            if (DEBUG) console.warn(`Can't find region image for ${code} country code`);
            return null
        }
    }

    switch (true) {
        case !!cloudCode && !!flagsData['datacenter_' + cloudCode] :

            let datacenter = flagsData['datacenter_' + cloudCode];
            let foundDatacenterRegion = datacenter.find(datacenterRegion => region['id'] === datacenterRegion.code);

            if (!foundDatacenterRegion) {
                if (DEBUG) console.warn(`"${region['id']}" code wasn't found in ${'datacenter_' + cloudCode} config.`)
            } else {
                let foundCountry = findCountryData(foundDatacenterRegion.country);
                if (!!foundCountry) flag = {src: foundCountry.src, alt: foundCountry.alt};
            }
            break;
        // case region.name && regions.every(_region =>
        //     country_data.some(_country =>
        //         _country.city.some(_city => new RegExp(_city).test(_region.name) && _city.length)
        //     )
        // ) :
        case region.name && regions.every(r =>
            country_data.some(_country =>
                _country.city.some(_city => !!_city && r.name.includes(_city))
            )
        ) :
            country_data.map(country => {
                // if (country.city.some(city => new RegExp(city).test(region.name) && city.length)) {
                if (country.city.some(city => !!city && region.name.includes(city))) {
                    flag = {src: country.flag, alt: country.country}
                }
            });
            break;
        case !!region.country :
            let foundCountry = findCountryData(region.country);
            if (!!foundCountry) flag = {src: foundCountry.src, alt: foundCountry.alt};
            break;
        default:
            if (DEBUG) {console.warn('Invalid county flag settings')}
            break;
    }

    return flag
}

export function handleRegionZones(region) {
    return region['zones'].map(zone => zone.replace(region.id, ''));
}